import axios from "../libs/axios/axios-assetupload";
import { BaseBulkUploadService } from "./basebulkupload.service";

export const api = new BaseBulkUploadService(axios);
